import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCombobox,{attrs:{"value":_vm.value,"label":_vm.label,"multiple":"","dense":"","chips":"","deletable-chips":"","small-chips":"","clearable":"","hide-selected":""},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }